import urlBuilder from '@sanity/image-url';
import {SanityBlockList} from '~/types/sanityTypes';
import {useSanityClient} from '~/lib/utils';

export function BlockList({blockContent}: {blockContent: SanityBlockList}) {
  console.log(blockContent);
  return (
    <>
      <div className="block-list">
        <div className="container">
          {blockContent.rows.map((row) => {
            let setImage =
              row.content[0]._type === 'image'
                ? urlBuilder(useSanityClient)
                    .image(row.content[0])
                    .width(1000)
                    .fit('max')
                    .auto('format')
                    .url()
                : '';

            return (
              <div
                key={row._key}
                className="list-row border-b py-6 flex md:justify-between"
              >
                <div className="flex">
                  {'linkExternal' === row.content[0]._type && (
                    <a
                      className="uppercase underline transition-opacity duration-200 hover:opacity-60"
                      href={row.content[0].url}
                      rel="noopener noreferrer"
                      target={row.content[0].newWindow ? '_blank' : '_self'}
                    >
                      {row.content[0].title}
                    </a>
                  )}
                  {'Text' === row.content[0]._type && (
                    <span className="uppercase">{row.content[0].text}</span>
                  )}
                  {'image' === row.content[0]._type && (
                    <div className="flex justify-center items-center w-full max-w-[450px] ">
                      <img
                        src={setImage}
                        alt={'Mareksound Kartta'}
                        loading="eager"
                        className="w-full object-contain rounded-sm"
                      />
                    </div>
                  )}
                </div>
                <div className="font-clash uppercase hidden md:flex">
                  {row.title}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
